var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mounter",staticClass:"full"},[_c('a',{staticClass:"aroundbtn",attrs:{"href":"/exp"}},[_vm._v(" Experiment "),_c('br'),_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }